<template>
  <v-main>
    <v-container grid-list-md fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <v-card class="elevation-12">
            <template>
              <v-form ref="form" @submit.prevent="resetPassword">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>{{$t("Request new password")}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                    v-model="user.username" :label="t.Username"
                    required prepend-icon="person" name="login" type="text">
                  </v-text-field>
                  <v-text-field
                    v-model="user.password" :rules="passwordRules" :label="t.New_password"
                    required prepend-icon="lock" id="password" name="password" type="password">
                  </v-text-field>
                  <v-text-field
                    v-model="user.password2"
                    :rules="[v => v === user.password || $t('Passwords must match')]"
                    :label="t.Repeat_new_password"
                    required prepend-icon="lock" id="password2" name="password2" type="password">
                  </v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="secondary" to="/">{{$t("Back to login")}}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn :loading="loading" color="success" type="submit">{{$t("Submit")}}</v-btn>
                </v-card-actions>
              </v-form>
            </template>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import * as Security from '@/core/security'
import { app } from '@/main'

function uniqueChars (str) {
  return String.prototype.concat(...new Set(str)).length
}

function isNummeric5digits (str) {
  return str.length === 5 && !isNaN(str)
}

export default {
  name: 'login',
  data () {
    return {
      loading: false,
      user: {
        username: '',
        password: '',
        password2: ''
      },
      // Consider putting these rules into rules.js
      passwordRules: [
        v => !!v || this.$t('Field is required'),
        v => /^[a-zA-Z0-9_!@#%&^$]+$/.test(v) || this.$t('Illegal characters in password'),
        v => (v.length >= 5 && v.length <= 16) || this.$t('Password must be between 5 and 16 characters'),
        v => (uniqueChars(v) >= 3 || isNummeric5digits(v)) || this.$t('Password must have at least 3 unique characters'),
        v => !v.includes(this.user.username) || this.$t('Password must not include username'),
        v => (/^[a-zA-Z].*$/.test(v) || isNummeric5digits(v)) || this.$t('First character must be a letter')
      ],
      message: null
    }
  },
  computed: {
    t () {
      return {
        Username: this.$t('Username'),
        New_password: this.$t('New password'),
        Repeat_new_password: this.$t('Repeat new password')
      }
    }
  },
  mounted () {
    if (Security.user.loggedIn) this.$router.push({ name: 'welcome' })
  },
  methods: {
    async resetPassword () {
      if (this.$refs.form.validate()) {
        this.loading = true
        const res = await Security.resetPassword({
          username: this.user.username,
          password: this.user.password
        })
        this.loading = false
        if (!res.failed) {
          app.$root.$message.showSuccess(app.$t('Email with activation link will arrive in a moment'))
          this.$router.push({ name: 'login' })
        }
      }
    }
  }
}
</script>
